import React, { FunctionComponent, ReactNode } from "react";
import ReactTooltip, { Place } from "react-tooltip";
import { TooltipWrapper, TooltipView, TooltipCloseView } from "./styles";
import iconClose from "../../../assets/cancel.svg";
import overridePositionFunc from "./overridePosition";
import { TooltipProps } from "./helpers";

export const Tooltip: FunctionComponent<TooltipProps> = ({
    children,
    place,
    id,
    arrowColor,
    className,
    offset,
    hideTooltipCloseButton = true,
    ...rest
}) => (
    <TooltipWrapper>
        <ReactTooltip
            arrowColor={arrowColor}
            className={`${className} tooltip`}
            clickable={true}
            effect="solid"
            globalEventOff="click"
            id={id}
            multiline={true}
            overridePosition={overridePositionFunc}
            place={place}
            {...rest}
            eventOff="click"
            offset={offset}
        >
            <TooltipView>
                {!hideTooltipCloseButton && (
                    <TooltipCloseView>
                        <img alt="cancel" height="100%" src={iconClose} width="24" />
                    </TooltipCloseView>
                )}
                {children}
            </TooltipView>
        </ReactTooltip>
    </TooltipWrapper>
);

Tooltip.defaultProps = {
    arrowColor: "#fff"
};

export default Tooltip;
